import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { runWhenPageReady } from '../utils/PageLifecycle';

gsap.registerPlugin(ScrollTrigger);

class ParallaxImages {
  constructor() {
    this.parallaxElements = document.querySelectorAll('[data-parallax]');
    this.zoomRevealImages = document.querySelectorAll('[data-zoom-reveal]');
    
    if (this.parallaxElements.length > 0 || this.zoomRevealImages.length > 0) {
      this.init();
    }
  }

  init() {
    // Handle zoom reveals on load
    this.initZoomReveals();
    
    // Handle parallax scrolling - wait for zoom to finish
    // The parallax will take over after zoom animation completes (6.5s = 0.5 delay + 6.0 duration)
    setTimeout(() => {
      this.initParallax();
    }, 6500);
  }

  initZoomReveals() {
    this.zoomRevealImages.forEach((img) => {
      // Set initial state - image zoomed in, but still visible to avoid a gray flash
      // Start at centered position for 1.3x scale
      gsap.set(img, {
        scale: 1.3,
        opacity: 1,
        y: 0,
        yPercent: -7.5
      });

      // Animate to final position - zoom out but stay larger for parallax
      // End at centered position for 1.15x scale
      gsap.to(img, {
        scale: 1.15,
        y: 0,
        yPercent: -3.75,
        duration: 6.0,
        ease: 'expo.out',
        delay: 0
      });
    });
  }

  initParallax() {
    this.parallaxElements.forEach((element) => {
      const parallaxValue = parseFloat(element.dataset.parallax) || 0.3;
      // Find the closest hero container (works with all hero types)
      const trigger = element.closest('.hero-section, .hero-simple, section');

      // Don't use fromTo - just animate TO the end value
      // Let GSAP calculate from current position (where zoom left it)
      gsap.to(element, {
        y: 0,
        yPercent: -3.75 + 20, // End value: 16.25
        ease: 'none',
        scrollTrigger: {
          trigger: trigger,
          start: 'top top', // Start when hero reaches top of viewport
          end: 'bottom top',
          scrub: true
        }
      });
    });
  }
}

runWhenPageReady(() => new ParallaxImages());

export default ParallaxImages;
